export const getImportSummaryCellStyle = () => ({
  '& .status-row': {
    position: 'relative',

    '&>div, &>div>div, &>div>div>div': {
      display: 'inline',
    },

    '&>div': {
      '& .status-image': {
        position: 'relative',
      },

      '& .status_icon': {
        marginLeft: 5,
        position: 'relative',
        top: 1,
      },

      '& .status-icon': {
        marginRight: 5,
        position: 'relative',
        top: 3,
      },
    },
  },
});
